module.exports = "<div ng-if=\"$ctrl.showLoader\" class=\"loader-component\">\r\n    <div class=\"loader-component__loader\">\r\n    </div>\r\n    <div class=\"loader-component__label\"> {{$ctrl.description}}</div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./components/loader/loader.html
// module id = 100
// module chunks = 0